const ROUTES = {
  home: { name: "Home", path: "/" },
  login: { name: "Login", path: "/login" }
};

export { ROUTES };
